import styled from "styled-components";

const StylesContainer = styled.div`
  background: ${({ token }) => token.page_dashboard__background};
  overflow: auto;
  position: relative;

  &::before {
    content: "";
    background: ${({ token }) => token.page_dashboard__hero_background};
    background-size: cover;
    height: 500px;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 0;
  }

  .container-page {
    margin: 0 auto;
    padding: 40px;
    width: 1124px;
  }

  h3 {
    border-bottom: 1px solid rgba(218, 222, 229, 0.3);
    color: #fff;
    font-size: 19px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 0;
    padding: 7px 0;
    position: relative;
  }

  h4 {
    color: #9d9d9d;
    font-size: 18px;
    font-weight: 400;
    margin: unset;
  }

  main {
    display: flex;
    gap: 31px;
    justify-content: center;
    height: 100%;
    min-width: fit-content;
  }

  .container-marketing {
    backdrop-filter: blur(11px);
    background: linear-gradient(
      180deg,
      rgba(15, 41, 50, 0) 0%,
      rgba(8, 37, 48, 0.25) 100%
    );
    border-radius: 12px;
    border-top: 1px solid rgba(255, 255, 255, 0.4);
    box-shadow:
      0 4px 4px 0 rgba(0, 0, 0, 0.25),
      0 8px 20px 0 rgba(0, 0, 0, 0.54);
    height: fit-content;
    padding: 16px;

    iframe {
      border-radius: 12px;
    }

    .news-section {
      background: #ffffff;
      border-radius: 12px;
      display: flex;
      flex-direction: column;

      header {
        padding: 16px 24px;
        border-bottom: 1px solid #e8e8e8;

        h3 {
          border-bottom: unset;
          color: #215054;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          margin: 0;
        }
      }
    }
  }
`;

export default StylesContainer;
